module.exports = __webpack_public_path__ + "static/img/20003 (7).0bc0b49.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20003 (7).webp
// module id = NDpK
// module chunks = 14